import styled from '@emotion/styled'
import cx from 'classnames'

import { Countdown } from '@/components/Countdown'
import type { HasCountdownProps } from '@/components/Countdown/types'
import { HeadingL, SubHeading } from '@/components/Typography'
import { parseIsoToTimestampMS } from '@/core/utils/date/parseIsoToTimestampMS'
import type { TitleProps } from '@/models'
import { CONFIG } from '@/styles/emotion.config'

const HeroBlockStyles = styled.div({
  textAlign: 'left',
  margin: `var(--space-m) auto`,
  borderBottom: '1px solid rgba(var(--theme-surface-silver))',
  [CONFIG.media.lg]: {
    maxWidth: 'calc(960px - 2rem)',
  },
})

interface Props extends HasCountdownProps {
  title: TitleProps
  subtitle?: TitleProps
  id?: string
}

const HeroBlock = ({
  id,
  title,
  subtitle,
  hasCountdown,
  clockBackGround,
  clockBackGroundHex,
  labelColorModifier,
  clockColorModifier,
  countdownDate,
  countdownDay,
}: Props) => {
  const countdownProps = {
    clockBackGround,
    clockBackGroundHex,
    labelColorModifier,
    clockColorModifier,
    countdownTimestampMs: parseIsoToTimestampMS(countdownDate),
    daysFromInput: countdownDay || 2,
  }

  return (
    <div className="ecs-container" id={id}>
      <HeroBlockStyles className="eu-sp-2">
        <HeadingL className="eu-sm-1" tag={title.tag || 'h1'}>
          {title.text}
        </HeadingL>
        {subtitle && subtitle.text && (
          <SubHeading
            dark="low"
            className={cx('subtitle', { 'eu-sm-2': hasCountdown })}
            tag={subtitle.tag}
          >
            {subtitle.text}
          </SubHeading>
        )}
        {hasCountdown && countdownProps && <Countdown className="e eu-sm-2" {...countdownProps} />}
      </HeroBlockStyles>
    </div>
  )
}

export default HeroBlock
